module.exports = __webpack_public_path__ + "img/Order-background.16abf707.png";